/**
 * Created by phatbass on 2/9/16.
 */

angular.module('far.fos_user')
    .controller('LoginController', function (hideShowPassword) {
        var vm = {
            hideShowPassword: hideShowPassword
        };
        return vm;
    });